import { Message } from "element-ui";
const request = require("../request-utils.js");
import { callFeign, callFeignV1 } from "../api-utils/api-callFeign.js";
import commonUtils from "../common-utlis.js";

/**
 * 创建退款申请
 */
const createSellbackOrder = (sellbackInfo) => {
	return new Promise((resolve, reject) => {
		request.default.jackyunPost({
				method: "jmall.trade.createsellbackorder",
				jsonStr: JSON.stringify(sellbackInfo),
			},
			(res) => {
				let data = res.code == 200 && res.result.data;
				let sellbackTypeName = sellbackInfo.sellbackType == 1 ? "退款" : "退货";
				if (data) {
					Message.success(`${sellbackTypeName}申请创建成功`);
				} else {
					console.log("创建退款申请失败：", res);
					Message.error(res.msg || `${sellbackTypeName}申请创建失败`);
				}
				resolve(data);
			}
		);
	});
};

/**
 * 获取已经申请了退款的商品列表
 */
const getRefundedGoodsList = (jackyunTradeNo) => {
	return new Promise((resolve, reject) => {
		request.default.jackyunPost({
				method: "jmall.trade.getrefundedgoodslistbyjackyuntradeno",
				jsonStr: JSON.stringify({
					jackyunTradeNo,
				}),
			},
			(res) => {
				let data = [];
				if (res.code == 200) {
					data = res.result.data;
				} else {
					console.log("获取已经申请了退款的商品列表失败：", res);
				}
				resolve(data);
			}
		);
	});
};

/**
 * 根据吉客云销售单号获取退款单状态
 */
const getRefundStatusByJackyunTradeNo = (jackyunTradeNoList) => {
	return new Promise((resolve, reject) => {
		request.default.jackyunPost({
				method: "jmall.trade.getrefundstatusbyjackyuntradeno",
				jsonStr: JSON.stringify({
					jackyunTradeNoList,
				}),
			},
			(res) => {
				let data = [];
				if (res.code == 200) {
					data = res.result.data || [];
				} else {
					console.log("获取退款单状态失败：", res);
				}
				resolve(data);
			}
		);
	});
};

/**
 * 根据吉客云销售单号获取退款单状态
 */
const getReshipmentGoods = (tradeNo) => {
	return new Promise((resolve, reject) => {
		callFeignV1("ass-business.exchange.getexchangegoodsbytradeno", {
			jsonStr: JSON.stringify({
				bizContent: {
					tradeNo,
					bModifyPage: false,
					isUseCache: false,
					needDataMask: false,
					useCache: false,
				},
			}),
		}).then((res) => {
			let data = [];
			if (res && res.code == 200) {
				let temp = JSON.parse((res && res.result && res.result.data) || "{}");

				data = temp.items || [];
			}
			resolve(data);
		});
	});
};

/**
 * 获取退货地址
 */
const getSellBackAddress = (channelId, warehouseId) => {
	return new Promise((resolve, reject) => {
		callFeignV1("assbusiness.open.getreturnaddressinfo", {
			jsonStr: JSON.stringify({
				bizContent: {
					itemList: [{
						shopId: channelId,
						warehouseId,
					}, ],
				},
			}),
		}).then((res) => {
			let data = [];
			if (res && res.code == 200) {
				let temp = JSON.parse((res.result && res.result.data) || "{}");
				data = temp.items || [];
			}
			let sellerAddressInfo = (data[0] && data[0].sellerAddressInfo) || {};
			resolve(sellerAddressInfo);
		});
	});
};

/**
 * 获取发货仓库地址
 */
const getSellerWarehouseAddress = (warehouseId) => {
	return new Promise((resolve, reject) => {
		callFeignV1("erp.warehouse.get", {
			warehouseId,
		}).then((res) => {
			let data = {};
			if (res && res.code == 200) {
				data = res.result.data || {};
			}
			resolve(data);
		});
	});
};

/**
 * 批量查询卡券是否能退
 */
const getCouponCanrefund = (ticketIds) => {
	return new Promise((resolve, reject) => {
		request.default.jackyunPost({
				method: "jmall.coupon.checkcanrefund",
				jsonStr: JSON.stringify({
					ticketIds,
				}),
			},
			(res) => {
				let data = [];
				if (res.code == 200) {
					data = res.result.data.canNotTicketIdList || [];
				}
				resolve(data);
			}
		);
	});
};

/**
 * 订单退款单状态处理（一个订单可能对应多个退款单）
 * @param {*} refundStatusList 
 * @param {*} tradeInfo 
 */
const processingTradeRefundStatus = (refundStatusList, trade = {}) => {
	/**
	 * 退款状态（0待审核，1驳回，2审核通过）
	 * 退款类型（0退款，1退货）
	 */

	// 根据退款状态去重，多个相同状态的退款单做同样的状态处理
	refundStatusList = commonUtils.distinctArr(refundStatusList, "sellbackStatus");
	if (!(refundStatusList && refundStatusList.length > 0)) {
		trade.sellbackStatus = -1;
		trade.sellbackType = -1;
		trade.sellbackStatusExplain = "";
		return trade;
	}

	// 当前订单退款状态，单一有效的状态数据
	let curTradeRefundInfo;
	if (refundStatusList && refundStatusList.length == 1) {
		curTradeRefundInfo = refundStatusList[0];
	} else {
		// 去除“驳回”状态的单据，以当前生效的退款单为准
		let refundStatusNotRejectList = refundStatusList.filter(t => t.sellbackStatus != 1);
		if (refundStatusNotRejectList && refundStatusNotRejectList.length == 1) {
			curTradeRefundInfo = refundStatusNotRejectList[0];
		}
	}

	// 没有单一可判断的退款单状态，存在多条退款单状态的情况，显示“退款”或者“退货”
	if (!curTradeRefundInfo) {
		trade.sellbackStatus = refundStatusList[0].sellbackStatus;
		trade.sellbackType = refundStatusList[0].sellbackType;
		trade.sellbackStatusExplain = refundStatusList[0].sellbackType == 2 ? "退货" : "退款";
		return trade;
	}

	// 退款状态（0待审核，1驳回，2同意）
	trade.sellbackStatus = curTradeRefundInfo.sellbackStatus;
	// 退款类型（1退款，2退货）
	trade.sellbackType = curTradeRefundInfo.sellbackType;
	// 退款状态说明
	if (trade.sellbackType == 1 && trade.sellbackStatus == 0) {
		trade.sellbackStatusExplain = "待商家同意退款";
	} else if (trade.sellbackType == 1 && trade.sellbackStatus == 1) {
		trade.sellbackStatusExplain = "商家拒绝退款";
	} else if (trade.sellbackType == 1 && trade.sellbackStatus == 2) {
		trade.sellbackStatusExplain = "退款成功";
	} else if (trade.sellbackType == 2 && trade.sellbackStatus == 0) {
		trade.sellbackStatusExplain = "待商家同意退货";
	} else if (trade.sellbackType == 2 && trade.sellbackStatus == 1) {
		trade.sellbackStatusExplain = "商家拒绝退货";
	} else if (trade.sellbackType == 2 && trade.sellbackStatus == 2) {
		trade.sellbackStatusExplain = "退货成功";
	} else {
		trade.sellbackStatusExplain = "退款/退货";
	}
	return trade;
}

export default {
	createSellbackOrder,
	getRefundedGoodsList,
	getRefundStatusByJackyunTradeNo,
	getReshipmentGoods,
	getSellBackAddress,
	getSellerWarehouseAddress,
	getCouponCanrefund,
	processingTradeRefundStatus,
};